import React, { useEffect, useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { visitorId } from '../utils/trackPageView';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const LABEL = { fr: 'Avec le soutien de', en: 'With the support of', es: 'Con el apoyo de', de: 'Mit Unterstützung von' };

// Bandeau « Avec le soutien de » : parrains locaux geres depuis l'administration (page « Parrains »).
// Sans cookie ni traceur tiers : seul un compteur d'affichages et de clics est tenu cote serveur.
function SponsorBand({ language = 'fr' }) {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    let alive = true;
    fetch(`${API_URL}/sponsors/active`)
      .then((r) => (r.ok ? r.json() : { sponsors: [] }))
      .then((d) => {
        if (!alive) return;
        const list = d.sponsors || [];
        setSponsors(list);
        // Un affichage compte une fois par session et par parrain.
        list.forEach((s) => {
          const key = `sponsor_seen_${s.id}`;
          try {
            if (sessionStorage.getItem(key)) return;
            sessionStorage.setItem(key, '1');
          } catch { return; }
          const visitor = visitorId();
          if (!visitor) return;
          fetch(`${API_URL}/sponsors/${s.id}/view`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ visitor }), keepalive: true,
          }).catch(() => {});
        });
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (sponsors.length === 0) return null;
  return (
    <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid', borderColor: 'divider', textAlign: 'center' }} aria-label={LABEL[language] || LABEL.fr}>
      <Typography variant="overline" color="text.secondary">{LABEL[language] || LABEL.fr}</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'stretch', gap: 2, flexWrap: 'wrap', mt: 1 }}>
        {sponsors.map((s) => {
          const inner = (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, maxWidth: 180, p: 1 }}>
              {s.has_image && <Box component="img" src={`${API_URL}/sponsors/${s.id}/image`} alt={s.name} loading="lazy" sx={{ maxHeight: 64, maxWidth: 160, objectFit: 'contain' }} />}
              <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>{s.name}</Typography>
              {s.text && <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.2 }}>{s.text}</Typography>}
            </Box>
          );
          return s.has_link ? (
            <Link key={s.id} href={`${API_URL}/sponsors/${s.id}/click`} target="_blank" rel="sponsored noopener noreferrer" underline="none" color="inherit" sx={{ '&:hover': { opacity: 0.8 } }}>{inner}</Link>
          ) : <Box key={s.id}>{inner}</Box>;
        })}
      </Box>
    </Box>
  );
}

export default SponsorBand;
